import React, {ReactElement} from 'react';
import {strings} from "../../strings/strings";
import active from '../../images/travel/active.svg'
import covid from '../../images/travel/covid.svg'
import franchise from '../../images/travel/zero-franschize.svg'
import age_range from '../../images/travel/age_range.svg'
import contract from '../../images/travel/contract.svg'
import TravelAdvantages from "../TravelAdvantages";
import {FormRow} from "../Form/FormRow";
import "./index.scss";

export const TravelAdvantagesList = ():ReactElement => {

    return (
        <>
            <h3 className='travel-advantages-list'>{strings.ourAdv}</h3>
            <FormRow type={'travel'} className={'start-form-step_row'} columns={3} contentNumber={5}>
                <TravelAdvantages icon={covid} text={strings.covidAdv}/>
                <TravelAdvantages icon={franchise} text={strings.franchiseAdv}/>
                <TravelAdvantages icon={active} text={strings.activeAdv}/>
                <TravelAdvantages icon={age_range} text={strings.ageRange}/>
                <TravelAdvantages icon={contract} text={strings.prohibitionCancelled}/>
            </FormRow>
        </>
    )
}